import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ClipboardIcon from '@mui/icons-material/AssignmentSharp';
import ClipboardSuccessIcon from '@mui/icons-material/AssignmentTurnedInSharp';
import ClipboardErrorIcon from '@mui/icons-material/AssignmentLateSharp';

export default function CopyToClipboardButton({ data }: { data: string }) {
  // Reset status when `data` changes — the previously copied content is
  // stale, so the icon shouldn't keep showing SUCCESS/ERROR. Adjusting state
  // during render per the React docs' previous-prop pattern.
  const [prevData, setPrevData] = useState(data);
  const [status, setStatus] = useState<'INIT' | 'ERROR' | 'SUCCESS'>('INIT');
  if (prevData !== data) {
    setPrevData(data);
    setStatus('INIT');
  }

  function doCopy() {
    navigator.clipboard.writeText(data).then(
      () => setStatus('SUCCESS'),
      () => setStatus('ERROR'),
    );
  }

  switch (status) {
    case 'INIT':
      return (
        <IconButton title="Copy to clipboard" onClick={doCopy}>
          <ClipboardIcon />
        </IconButton>
      );
    case 'ERROR':
      return (
        <IconButton title="Could not copy to clipboard" onClick={doCopy}>
          <ClipboardErrorIcon />
        </IconButton>
      );
    case 'SUCCESS':
      return (
        <IconButton title="Copied to clipboard" onClick={doCopy}>
          <ClipboardSuccessIcon />
        </IconButton>
      );
  }
}
